<template>
  <div>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="name"
          :counter="20"
          label="学校名"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="11">
        <v-text-field
          v-model="code"
          label="学校コード"
          :counter="10"
        ></v-text-field>
      </v-col>
      <v-col cols="1" class="pt-9 pb-2">
        <v-btn
          color="secondary"
          x-small
          :disabled="!code"
          @click="search">
          検索
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="zipCode"
          label="郵便番号"
          :counter="7"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-select
          v-model="prefectureCode"
          :items="prefectures"
          item-text="name"
          item-value="code"
          label="都道府県"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="address"
          label="住所"
          :counter="100"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="accountName"
          label="担当者名"
          :counter="10"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="tel"
          label="電話番号"
          :counter="11"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="mail"
          label="メールアドレス"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="storeName"
          label="販売店名"
          :counter="20"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12">
        <v-text-field
          v-model="storeMail"
          label="販売店メールアドレス"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="12" style="display: flex">
        <v-text-field
          type="number"
          v-model="student1Cnt"
          label="中１生徒数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="teacher1Cnt"
          label="中１教師用"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="class1Cnt"
          label="クラス数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          :value="Number(student1Cnt) + Number(teacher1Cnt) + (Number(class1Cnt) * 2)"
          readonly
          label="出力数"
        ></v-text-field>
      </v-col>
      <v-col cols="12" style="display: flex">
        <v-text-field
          type="number"
          v-model="student2Cnt"
          label="中２生徒数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="teacher2Cnt"
          label="中２教師用"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="class2Cnt"
          label="クラス数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          :value="Number(student2Cnt) + Number(teacher2Cnt) + (Number(class2Cnt) * 2)"
          readonly
          label="出力数"
        ></v-text-field>
      </v-col>
      <v-col cols="12" style="display: flex">
        <v-text-field
          type="number"
          v-model="student3Cnt"
          label="中３生徒数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="teacher3Cnt"
          label="中３教師用"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          v-model="class3Cnt"
          label="クラス数"
          class="pr-10"
        ></v-text-field>
        <v-text-field
          type="number"
          :value="Number(student3Cnt) + Number(teacher3Cnt) + (Number(class3Cnt) * 2)"
          readonly
          label="出力数"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-btn class="mt-6 ml-6" small color="secondary" dark @click.stop="submit">保存</v-btn>
  </div>
</template>

<script>
export default {
  computed: {
    name: {
      get () {
        return this.$store.state.school.name
      },
      set (value) {
        this.$store.commit('school/setName', {
          name: value
        })
      }
    },
    code: {
      get () {
        return this.$store.state.school.code
      },
      set (value) {
        this.$store.commit('school/setCode', {
          code: value
        })
      }
    },
    accountName: {
      get () {
        return this.$store.state.school.accountName
      },
      set (value) {
        this.$store.commit('school/setAccountName', {
          accountName: value
        })
      }
    },
    tel: {
      get () {
        return this.$store.state.school.tel
      },
      set (value) {
        this.$store.commit('school/setTel', {
          tel: value
        })
      }
    },
    mail: {
      get () {
        return this.$store.state.school.mail
      },
      set (value) {
        this.$store.commit('school/setMail', {
          mail: value
        })
      }
    },
    prefectureCode: {
      get () {
        return this.$store.state.school.prefectureCode
      },
      set (value) {
        this.$store.commit('school/setPrefectureCode', {
          prefectureCode: value
        })
      }
    },

    prefectures() {
      return this.$store.state.master.allPrefectures
    },
    storeName: {
      get() {
        return this.$store.state.school.storeName
      },
      set(value) {
        this.$store.commit('school/setStoreName', {
          storeName: value
        })
      }
    },
    storeMail: {
      get() {
        return this.$store.state.school.storeMail
      },
      set(value) {
        this.$store.commit('school/setStoreMail', {
          storeMail: value
        })
      }
    },
    address: {
      get() {
        return this.$store.state.school.address
      },
      set(value) {
        this.$store.commit('school/setAddress', {
          address: value
        })
      }
    },
    zipCode: {
      get() {
        return this.$store.state.school.zipCode
      },
      set(value) {
        this.$store.commit('school/setZipCode', {
          zipCode: value
        })
      }
    },
    student1Cnt: {
      get() {
        return this.$store.state.school.student1Cnt
      },
      set(value) {
        this.$store.commit('school/setStudent1Cnt', {
          student1Cnt: value
        })
      }
    },
    student2Cnt: {
      get() {
        return this.$store.state.school.student2Cnt
      },
      set(value) {
        this.$store.commit('school/setStudent2Cnt', {
          student2Cnt: value
        })
      }
    },
    student3Cnt: {
      get() {
        return this.$store.state.school.student3Cnt
      },
      set(value) {
        this.$store.commit('school/setStudent3Cnt', {
          student3Cnt: value
        })
      }
    },
    teacher1Cnt: {
      get() {
        return this.$store.state.school.teacher1Cnt
      },
      set(value) {
        this.$store.commit('school/setTeacher1Cnt', {
          teacher1Cnt: value
        })
      }
    },
    teacher2Cnt: {
      get() {
        return this.$store.state.school.teacher2Cnt
      },
      set(value) {
        this.$store.commit('school/setTeacher2Cnt', {
          teacher2Cnt: value
        })
      }
    },
    teacher3Cnt: {
      get() {
        return this.$store.state.school.teacher3Cnt
      },
      set(value) {
        this.$store.commit('school/setTeacher3Cnt', {
          teacher3Cnt: value
        })
      }
    },
    class1Cnt: {
      get() {
        return this.$store.state.school.class1Cnt
      },
      set(value) {
        this.$store.commit('school/setClass1Cnt', {
          class1Cnt: value
        })
      }
    },
    class2Cnt: {
      get() {
        return this.$store.state.school.class2Cnt
      },
      set(value) {
        this.$store.commit('school/setClass2Cnt', {
          class2Cnt: value
        })
      }
    },
    class3Cnt: {
      get() {
        return this.$store.state.school.class3Cnt
      },
      set(value) {
        this.$store.commit('school/setClass3Cnt', {
          class3Cnt: value
        })
      }
    },
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('school/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },

    async search() {
      const res = await this.$axios.get(`/api/v1/admin/school_master/search?q[code_eq]=${this.code}`)
      if (!res.data.name) {
        this.$toasted.global.error({ message: '学校コードが正しくありません。' })
      } else {
        this.name =  res.data.name
        this.prefectureCode =  res.data.prefecture_code
        this.storeName = res.data.store_name
        this.storeMail = res.data.store_mail
        this.tel = res.data.tel
        this.address = res.data.address
        this.zipCode = res.data.zip_code
        this.student1Cnt = res.data.student_1_cnt ? res.data.student_1_cnt.toString() : ''
        this.student2Cnt = res.data.student_2_cnt ? res.data.student_2_cnt.toString() : ''
        this.student3Cnt = res.data.student_3_cnt ? res.data.student_3_cnt.toString() : ''
      }
    },
  },

}
</script>

<style lang="stylus" scoped>

</style>
